import { UnsplashService } from "../../../../../server/api/unsplash";

const unsplashWebsite = "https://unsplash.com/photos/";

export const getImageDetails = async (
  getToken: () => Promise<string>,
  url: string,
): Promise<{ url: string; downloadUrl?: string }> => {
  let imageUrl;
  let downloadUrl = undefined;

  if (url.startsWith(unsplashWebsite)) {
    const photoId = url.split(unsplashWebsite)[1]!;

    const result = await new UnsplashService(await getToken()).getId(photoId);

    if (result.error || !result.data) {
      throw result.error;
    } else {
      imageUrl = result.data.full.urls.small;
      downloadUrl = result.data.full.links.download_location;
    }
  } else {
    imageUrl = url;
  }

  const response = await fetch(imageUrl);

  if (response.status !== 200) throw "Image not found";

  return { url: imageUrl, downloadUrl };
};
